export default "__VITE_ASSET__o0lR14Yp__"